import { createSelector } from 'reselect'

const selector = state => state.invoiceReducer

export const invoiceLoadSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const invoiceIvoicesSelector = createSelector(
  [selector],
  ({ invoices }) => invoices
)

export const invoiceLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const invoiceErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const invoiceSelector = createSelector(
  [selector],
  invoice => invoice
)
